import { formatMoneyValue } from "@/app/utils/formatMoneyValue";

export const externalTooltipHandler = (context: any) => {
  const { chart, tooltip } = context;

  let tooltipEl = document.getElementById("chartjs-tooltip");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = "chartjs-tooltip";
    document.body.appendChild(tooltipEl);
  }

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    return;
  }

  tooltipEl.style.position = "absolute";
  tooltipEl.style.background = "rgba(0, 0, 0, 0.8)";
  tooltipEl.style.border = "none";
  tooltipEl.style.borderRadius = "10px";
  tooltipEl.style.boxShadow = "0 10px 25px rgba(0,0,0,0.08)";
  tooltipEl.style.padding = "12px 14px";
  tooltipEl.style.pointerEvents = "none";
  tooltipEl.style.zIndex = "9999";
  tooltipEl.style.height = "auto";
  tooltipEl.style.maxHeight = "none";
  tooltipEl.style.overflow = "visible";
  tooltipEl.style.maxWidth = "380px";

  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body;

    let partnersHtml = "";

    bodyLines.forEach((_: any, i: number) => {
      const datasetIndex = tooltip.dataPoints?.[i]?.datasetIndex;
      const dataIndex = tooltip.dataPoints?.[i]?.dataIndex;

      const dataset = chart.data.datasets[datasetIndex];

      const transactionCount = dataset?.totals?.[dataIndex]?.count ?? 0;

      const transactionValue = formatMoneyValue(
        dataset?.totals?.[dataIndex]?.total ?? 0,
      );

      const colors = tooltip.labelColors?.[i];

      const partnerColor = colors?.backgroundColor || dataset?.borderColor;

      const label = dataset?.label || "";

      partnersHtml += `
      <div
        style="
          display:flex;
          flex-direction:column;
          gap:4px;
          margin-bottom:10px;
        "
      >
        <div
          style="
            display:flex;
            align-items:center;
            gap:8px;
            font-size:15px;
            font-weight:600;
            color:white;
          "
        >
          <span
            style="
              width:10px;
              height:10px;
              border-radius:3px;
              background:${partnerColor};
              display:inline-block;
              flex-shrink:0;
            "
          ></span>

          ${label}
        </div>

<div
  style="
    font-size:14px;
    color:rgba(255,255,255,0.9);
    padding-left:18px;
    line-height:1.4;
  "
>
  <b>${transactionValue}</b> (${transactionCount})
</div>
      </div>
    `;
    });

    const columns = bodyLines.length > 5 ? 2 : 1;

    tooltipEl.innerHTML = `
    <div
      style="
        font-size:15px;
        font-weight:600;
        margin-bottom:10px;
        color:white;
      "
    >
      ${titleLines.join(" ")}
    </div>

    <div
      style="
        display:grid;
        grid-template-columns: repeat(${columns}, minmax(160px, 1fr));
        column-gap:28px;
      "
    >
      ${partnersHtml}
    </div>
  `;
  }

  tooltipEl.style.opacity = "1";

  const canvasRect = chart.canvas.getBoundingClientRect();

  const tooltipWidth = tooltipEl.offsetWidth;
  const tooltipHeight = tooltipEl.offsetHeight;

  const margin = 16;

  let left =
    canvasRect.left + window.scrollX + tooltip.caretX - tooltipWidth - margin;

  let top =
    canvasRect.top + window.scrollY + tooltip.caretY - tooltipHeight - margin;

  if (left < margin) {
    left = canvasRect.left + window.scrollX + tooltip.caretX + margin;
  }

  if (top + tooltipHeight > window.innerHeight - margin) {
    top =
      canvasRect.top + window.scrollY + tooltip.caretY - tooltipHeight - margin;
  }

  if (top < margin) {
    top = margin;
  }

  if (left < margin) {
    left = margin;
  }

  tooltipEl.style.left = `${left}px`;
  tooltipEl.style.top = `${top}px`;
};
